export default "__VITE_ASSET__C1QIm3kc__"